import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '../../shared/tabs.component';

import DetailsTab, { TaxEntryPropTypes } from '../viewTaxEntriesPage/detailsTab.component';
import ProposedSubledgerJournalGrid, { slJournalPropTypes } from '../common/proposedSubledgerJournalGrid.component';
import ProposedSubledgerBalanceGrid, { slDeferredBalancePropTypes } from '../common/proposedSubledgerBalanceGrid.component';

export const proposedJournalsPropTypes = PropTypes.shape({
  slJournal: slJournalPropTypes,
  slDeferredBalance: slDeferredBalancePropTypes,
}).isRequired;

export const TabTypes = {
  DETAILS: 'DETAILS',
  PROPOSED_SUBLEDGER_JOURNALS: 'PROPOSED_SUBLEDGER_JOURNALS',
  PROPOSED_SUBLEDGER_BALANCES: 'PROPOSED_SUBLEDGER_BALANCES',
};

class TaxEntryToImportDetails extends PureComponent {
  static propTypes = {
    taxEntry: TaxEntryPropTypes,
    proposedJournals: proposedJournalsPropTypes,
  };

  state = {
    activeTab: TabTypes.DETAILS,
  };

  changeTab = (event, tabType) => {
    this.setState({
      activeTab: tabType,
    });
  };

  render() {
    const { activeTab } = this.state;
    const { taxEntry: rawTaxEntry, proposedJournals } = this.props;
    const { slJournal, slDeferredBalance } = proposedJournals;

    const taxEntry = { ...rawTaxEntry, amount: rawTaxEntry.netAmount };

    return (
      <div className="tax-entry page-content-container">
        <Tabs
          defaultValue={TabTypes.DETAILS}
          value={activeTab}
          onChange={this.changeTab}
          className="a-tab-bar-margin-10"
          size="md"
        >
          <Tab value={TabTypes.DETAILS} label="Details">
            <DetailsTab
              taxEntry={taxEntry}
            />
          </Tab>

          <Tab value={TabTypes.PROPOSED_SUBLEDGER_JOURNALS} label="Proposed Subledger Journals">
            {slJournal ? (
              <ProposedSubledgerJournalGrid
                slJournal={slJournal}
              />
            ) : 'No Subledger Journals Available'}
          </Tab>

          <Tab value={TabTypes.PROPOSED_SUBLEDGER_BALANCES} label="Proposed Subledger Balances">
            {slDeferredBalance ? (
              <ProposedSubledgerBalanceGrid
                slDeferredBalance={slDeferredBalance}
              />
            ) : 'No Subledger Balances Available'}
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default TaxEntryToImportDetails;
